import {ActivityGroup} from './TransactionList';

export const mergeActivityGroups = (
  prev: ActivityGroup[],
  next: ActivityGroup[],
): ActivityGroup[] => {
  const merged = [...prev];

  for (const nextGroup of next) {
    const existing = merged.find(g => g.title === nextGroup.title);
    if (existing) {
      // same date section already exists — append transactions
      existing.transactions = [
        ...existing.transactions,
        ...nextGroup.transactions,
      ];
    } else {
      merged.push(nextGroup);
    }
  }

  return merged;
};
